import { forwardRef } from 'react';
import { PADDING_SIZE } from '../constants';

// We need this to be able to set a custom padding on top and bottom
export const InnerElement = forwardRef<
  HTMLDivElement,
  {
    style: {
      height: string;
    };
  }
>(({ style, ...rest }, ref) => (
  <div
    ref={ref}
    style={{ ...style, height: `${parseFloat(style.height) + PADDING_SIZE}px` }}
    {...rest}
  />
));

InnerElement.displayName = 'InnerElement';
